import { faPalette } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useState } from "react";

import { IconButton, useRebrand } from "@growtherapy/sprout-ui";
import { environmentIsProduction } from "../utils";
import { useFeatureGate } from "@statsig/react-bindings";
import { useMatch } from "react-router-dom";
import { PROVIDER_PATH } from "../config";

const rebrandKey = "rebrand-toggle";

// This is the only place in code that should change these classes
function toggleRebrand(enabled: boolean) {
  window.document.documentElement.classList.toggle("rebrand", enabled);
  window.document.documentElement.classList.toggle("theme-client", enabled);
  localStorage.setItem(rebrandKey, enabled.toString());
}

export function RebrandToggle() {
  const rebrand = useRebrand();
  const isProduction = environmentIsProduction();

  const { value } = useFeatureGate("rebrand_theme");
  // Since statsig does not provide a loading state, track it manually
  const [loadingFeatureGate, setLoadingFeatureGate] = useState(true);

  const isProviderView = !!useMatch(PROVIDER_PATH);

  // turn rebrand on/off based on FF value, always turn on in dev
  useEffect(() => {
    // rebrand only applies to clients for now
    if (isProviderView) return;

    if (isProduction) {
      // Use default value while loading, then use the actual gate value
      const defaultValue = true;
      toggleRebrand(loadingFeatureGate ? defaultValue : value);
      setLoadingFeatureGate(false);
    } else {
      toggleRebrand(true);
    }
  }, [value, loadingFeatureGate, isProduction, isProviderView]);

  // hide toggle for production, provider view, and cypress tests
  // @ts-ignore window.testConfig is defined in cypress tests
  if (isProduction || isProviderView || window.testConfig) return null;

  return (
    <IconButton
      use="primary"
      iconDefinition={faPalette}
      aria-label="rebrand toggle"
      className="fixed bottom-3 right-3 z-50 opacity-50 transition-colors hover:opacity-100"
      onClick={() => toggleRebrand(!rebrand)}
    />
  );
}
